module.exports = __webpack_public_path__ + "assets/media/Culture_001.9df281cd-ps.mp4";